module.exports = {
      id: "clock-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "assets/img/sprite-598bc0.svg#clock-usage",
      toString: function () {
        return this.url;
      }
    }